import * as React from 'react';
import { post } from '../../../model/post';
import { PostSentItem } from './PostSentItem';
import { Divider } from '@material-ui/core';
import Paper from '../../../ui-components/Containers/Paper';

interface IProps {
    getContent: (post: post) => any;
    postList: Array<post>
    classes: any;
    loadVotes: (idPost: string) => any;
    loadStatsVote: (idPost: string) => Promise<any>;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: IProps) => (
    <Paper title='Elenco'>
        {props.postList && props.postList.map(c =>
            <>
                <PostSentItem
                    classes={props.classes}
                    post={c}
                    key={c._id}
                    getContent={props.getContent}
                    loadVotes={props.loadVotes}
                    loadStatsVote={props.loadStatsVote}
                />
                <Divider />
            </>)}
    </Paper>
);
